import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import Maintopbar from "./maintopbar.tsx";
import "./CSS/Login.css";

export default function ForgotpasswordEmail() {
  const location = useLocation();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [emailMissing, setEmailMissing] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const emailParam = params.get("email");
    if (emailParam) {
      setEmail(emailParam);
      setEmailMissing(false);
    } else {
      setEmailMissing(true);
    }
  }, [location.search]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) {
      toast.error("Email is required to send a recovery email.", {
        position: "top-center",
        autoClose: 3000,
      });
      return;
    }

    try {
      const response = await axios.post(
        "https://timetrakerapi.sntservices.in/send-email-ForgotPassword",
        null, // No body because Email is in the query
        {
          params: { Email: email }, // <-- send email as query param
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      toast.success("Recovery email sent successfully!", {
        position: "top-center",
        autoClose: 3000,
      });

      setTimeout(() => {
        navigate("/login");
      }, 3000);
    } catch (err) {
      toast.error("Failed to send recovery email. Try again later.", {
        position: "top-center",
        autoClose: 3000,
      });
    }
  };

  return (
    <>
      <Maintopbar />
      <div className="form-wrapper">
        <div className="form-container forgot-password-container">
          <h2 className="form-title">Forgot Password</h2>
          {emailMissing && (
            <p style={{ color: "red", fontWeight: "bold" }}>
              No email provided. Please go back to the{" "}
              <Link to="/login">Login Page</Link> and enter your email.
            </p>
          )}
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Email:</label>
              <input
                type="email"
                name="email"
                value={email}
                disabled
                required
              />
            </div>

            <button type="submit" className="form-button" disabled={!email}>
              Send Email For Changed Password
            </button>
          </form>
        </div>
      </div>
    </>
  );
}
